// extracted by mini-css-extract-plugin
module.exports = {"overrides--PrimaryButton":"Checkbox_overrides--PrimaryButton__FV1PT"};